import {HTMLAttributes} from 'react';
import styled, {CSSProperties} from 'styled-components';
import {typographyStyle} from '@/components/Typography';
import {FlexCenter} from '@/styled-components';
import {interceptProps} from '@/styled-components/utils';
import {palette} from '@/styles/palette';

export interface IColorCircleWithIcon extends HTMLAttributes<HTMLDivElement> {
  placeholder?: string;
  icon?: string;
  color?: string;
  size?: 'large' | 'small' | number;
  border?: CSSProperties['border'];
}

export const ColorCircleWithIcon = ({
  icon,
  placeholder = '',
  color,
  size: sizeStr,
  border,
  children,
  ...props
}: IColorCircleWithIcon) => {
  const size =
    typeof sizeStr === 'number' ? sizeStr : sizeStr === 'small' ? 16 : 22;

  return (
    <Root
      style={{...props?.style, backgroundColor: color, border}}
      size={size}
      {...props}
    >
      {!!children ? (
        children
      ) : !!icon?.length ? (
        <img src={icon} alt="" />
      ) : (
        placeholder.slice(0, 1)
      )}
    </Root>
  );
};

const Root = styled(FlexCenter).withConfig({
  shouldForwardProp: interceptProps(['size']),
})<{
  size: number;
}>`
  border-radius: 100%;
  color: ${palette.white};
  font-weight: 700;
  box-sizing: border-box;
  img {
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }
  ${{...typographyStyle.medium12}}
  ${({size}) => `width: ${size}px; height: ${size}px;`}
`;
